export default {
  habitese: state => state.habitese
};
